<telxl-panel cardClass="h-100" [minHeight]="height()" [maxHeight]="height()">
    <ng-template telxlSharedOverlay></ng-template>
    <ng-template #cardBody>

        @if (hasPermission) {

            <div class="card-title">
                <telxl-tab
                    [tabs]="tabs"
                    [selected]="selected"
                    (selectedChange)="setSelected($event)"
                    containerClass="d-inline-block"
                    justifyContentClass="justify-content-end"
                    tabPaddingY="0.3rem"
                />
            </div>

            <div class="p-2">
                @if (selected === 'customer-details') {
                    <end-customer-panel
                        [workItem]="workitem()"
                        [customer]="customer()"
                        [allowNavigation]="allowNavigation()"
                        (updated)="onUpdated($event)"
                    />
                }
            </div>
        } @else {
            <div
                class="d-flex flex-column align-items-center justify-content-center overflow-hidden"
                [style.height]="height()"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No contact details were found.</div>
            </div>
        }
    </ng-template>
</telxl-panel>
